<template>
  <VisaForm country="israel" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" :date-hint="$tt('estimate_entry_in_2_years')" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <ExtraNationalityFields v-model="applicant.extraNationality" />
          <AddressFields v-model="applicant.address" hide-line />
        </template>
        <template #family>
          <FamilyDetailsFields v-model="applicant.family" has-marital-status />
        </template>
        <template #occupation>
          <OccupationFields v-model="applicant.occupation" has-phone />
        </template>
        <template #pastTravels>
          <AppRow>
            <EverVisitedRadio v-model="applicant.pastVisit.visited" />
            <v-expand-transition>
              <LastVisitYear v-if="applicant.pastVisit.visited" v-model="applicant.pastVisit.year" />
            </v-expand-transition>
          </AppRow>
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>